import {
  getCheckboxOrRadio,
  getTransformedRequiredFieldsForForm,
  RADIO_BUTTON
} from 'helpers/forms/menuItem';

/**
 * Parses options of type radio_button into arrays
 * @param {Array} requiredFields
 * @return {Object} transformed required fields
 **/
const getTransformedRequiredFieldsForCartItem = requiredFields => {
  const transformedRequiredFields = getTransformedRequiredFieldsForForm(
    requiredFields
  );
  const optionSlugs = Object.keys(transformedRequiredFields);

  optionSlugs.forEach((slug, index) => {
    const { min_qty, max_qty } = requiredFields[index];
    const fieldType = getCheckboxOrRadio(min_qty, max_qty);
    if (fieldType === RADIO_BUTTON) {
      transformedRequiredFields[slug] = [transformedRequiredFields[slug]];
    }
  });

  return transformedRequiredFields;
};

export default getTransformedRequiredFieldsForCartItem;
